import React from 'react';
import { coverageTags, overviewStats } from '../data/content';
export function ProductOverview() {
  return <section className="bg-navy-900 px-5 py-16 sm:py-20" data-id="element-187" data-mp="2ccllfop54yl2">
      <div className="mx-auto max-w-5xl text-center" data-id="element-188" data-mp="27ku506zp898n">
        <p className="inline-flex rounded-full bg-gold px-4 py-1.5 text-[10px] font-black uppercase tracking-[0.14em] text-navy-900 sm:text-xs" data-id="element-189" data-mp="27jiza1mp0rew">
          🏆 The Complete System To Stop Improvising Cricket Training
        </p>

        <h2 className="mt-7 font-display text-5xl font-black tracking-tight text-gold sm:text-6xl lg:text-7xl" data-id="element-190" data-mp="1yi2r80jcp1du">
          CRICKET READY™
        </h2>
        <p className="mt-3 text-sm font-bold uppercase tracking-[0.2em] text-white sm:text-base" data-id="element-191" data-mp="1ol6h5qdt0776">
          1 Complete Volume + 5 Strategic Bonuses
        </p>

        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/65" data-id="element-192" data-mp="1jp97g2x1pz3d">
          Over 200 pages. 50+ professional sessions. 60+ drills. Batting,
          Bowling, Fielding. Physical Preparation. Team Management. Everything
          ready.
        </p>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4" data-id="element-193" data-mp="10bx2dn6pd9tn">
          {overviewStats.map(stat => <div key={stat.label} className="rounded-xl border border-gold/25 bg-navy-700 px-4 py-6" data-id="element-194" data-mp="15ai1tke4rph1">
              <p className="font-display text-3xl font-black text-white" data-id="element-195" data-mp="vdvjb29a1ai6">
                {stat.value}
              </p>
              <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-gold" data-id="element-196" data-mp="1j5amsycshxv0">
                {stat.label}
              </p>
            </div>)}
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-2 rounded-2xl border border-white/10 bg-navy-800 px-5 py-6" data-id="element-197" data-mp="19d4x5va0fsiz">
          {coverageTags.map(tag => <li key={tag} className="rounded-md border border-white/10 bg-navy-700 px-3 py-1.5 text-xs font-semibold text-white/75" data-id="element-198" data-mp="222u0ifa704nr">
              {tag}
            </li>)}
        </ul>
      </div>
    </section>;
}